<div class="channel-control__wrapper">
  <input
    type="text"
    [class]="inputClass"
    [value]="displaySelectedItem()"
    [matAutocomplete]="auto"
    [placeholder]="'Search Channels'"
    (focus)="getRecords()"
    (input)="onInputChange($event)"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="onSelectItem($event.option.value)"
  >
    <ng-container *ngIf="!loadingRecords; else loadingTemplate">
      <mat-option
        *ngFor="let option of records; trackBy: trackById"
        [value]="option"
      >
        {{ option.label }}
      </mat-option>
    </ng-container>
    <ng-template #loadingTemplate>
      <mat-option>
        <div class="flex gap-4">
          <mat-progress-spinner
            class="progress-spinner mt-3"
            diameter="24"
            mode="indeterminate"
          ></mat-progress-spinner>
          <small>Loading...</small>
        </div>
      </mat-option>
    </ng-template>
  </mat-autocomplete>
</div>
